import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";
import { loadCart } from './load-cart';
// TODO: if cart is not loaded but is currently loading, wait for the cart to load instead of creating another new cart
export var getOrLoadCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
    var _getState, cart;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _getState = getState(), cart = _getState.cart;
          if (cart.data.id) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return dispatch(loadCart());
        case 4:
          return _context.abrupt("return", getState().cart);
        case 5:
          return _context.abrupt("return", cart);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getOrLoadCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();